import axios from 'axios'
import config from '../../config'

export default async function TempBooking(params) {

    let resp = false

    try {

        let data = { booking : { ...params } }
  
        let response = await axios(config.endpoint+'/api/v1/booking/setEntityTempBooking', {      
          method: 'post',
          data: JSON.stringify(data)
        })
        
        resp = response.data
    } catch (e) {
        console.log(e)
    }

    return resp
}